import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "64",
  height: "80",
  viewBox: "0 0 64 80",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      d: "M52 24v-4C52 8.972 43.028 0 32 0S12 8.972 12 20v12H8c-4.412 0-8 3.588-8 8v32c0 4.412 3.588 8 8 8h48c4.412 0 8-3.588 8-8V40c0-4.412-3.588-8-8-8H20V20c0-6.616 5.384-12 12-12s12 5.384 12 12v4h8Z",
      fill: "#FBBA00"
    }, null, -1)
  ])))
}
export default { render: render }